import { Directive, ElementRef, effect, input, inject } from '@angular/core';

import { ApResponsiveService } from './responsive.service';

/**
 * @deprecated.
 * Use the [CSS Grid](https://designsystem.acc.aws.devolksbank.net/index.html?path=/docs/components-style-grid--docs)
 * in ap/style instead
 */
@Directive({
    selector: '[xs]',
    providers: [ApResponsiveService]
})
export class ApXsDirective {
    private readonly el = inject(ElementRef);
    private readonly responsiveService = inject(ApResponsiveService);

    public readonly xs = input<number>(undefined);

    constructor() {
        effect(() => {
            this.responsiveService.addResponsiveClasses(this.el, this.xs(), 'xs');
        });
    }
}
